import { Fieldset } from "./types.ts";
import { merge } from "../../deps/merge.ts";

function setValue<T extends Fieldset>(fields: T, name: string, value: string) {
  const newFields = structuredClone(fields);
  newFields[name].value = value;
  return newFields;
}

function setConfirmValue<T extends Fieldset>(fields: T, name: string, value: string) {
  const newFields = structuredClone(fields);
  newFields[name].validation!.confirmed!.value = value;
  return newFields;
}

function setErrors<T extends Fieldset>(fields: T, name: string, errors: string[]) {
  const newFields = structuredClone(fields);
  newFields[name].errors = errors;
  return newFields;
}

function clearErrors<T extends Fieldset>(fields: T, name: string) {
  const newFields = structuredClone(fields);
  newFields[name].errors = [];
  return newFields;
}

export type ReducerAction<T extends Fieldset> =
  | { type: "markAsSubmitted"; actionData: T }
  | { type: "writeNewState"; newState: T }
  | { type: "errors"; name: string; value: string[] }
  | { type: "setValue" | "confirmValue"; name: string; value: string }
  | { type: "clearErrors"; name: string };
/* the reducer function */
export function reducer<T extends Fieldset>(state: T, action: ReducerAction<T>) {
  // console.log({ action, state });

  switch (action.type) {
    case "setValue":
      return setValue(state, action.name, action.value);
    case "confirmValue":
      return setConfirmValue(state, action.name, action.value);
    case "errors":
      return setErrors(state, action.name, action.value);
    case "clearErrors":
      return clearErrors(state, action.name);
    /* accepts a pre-mutated state object */
    case "writeNewState":
      return action.newState;
    case "markAsSubmitted":
      return {
        hasSubmitted: true,
        ...(merge(state, action.actionData ? action.actionData : {}) as T),
      } as unknown as T;

    default:
      throw Error("Unknown action.");
  }
}
